import log from '@diplodoc/transform/lib/log';
import imsize from '@diplodoc/transform/lib/plugins/imsize';
import isNumber from 'is-number';
import { imageNodeName } from '../../../markdown/Image/const';
import { ImgSizeAttr } from './const';
export { ImgSizeAttr };
export const ImgSizeSpecs = (builder, opts) => {
    var _a;
    const placeholderContent = (_a = builder.context.get('placeholder')) === null || _a === void 0 ? void 0 : _a.imgSize;
    builder.configureMd((md) => md.use(imsize, { log }));
    builder.addNode(imageNodeName, () => ({
        spec: {
            inline: true,
            attrs: {
                [ImgSizeAttr.Src]: {},
                [ImgSizeAttr.Alt]: { default: null },
                [ImgSizeAttr.Title]: { default: null },
                [ImgSizeAttr.Height]: { default: null },
                [ImgSizeAttr.Width]: { default: null },
                [ImgSizeAttr.Loading]: { default: null },
            },
            placeholder: placeholderContent ? { content: placeholderContent } : opts.placeholder,
            group: 'inline',
            draggable: true,
            parseDOM: [
                {
                    tag: 'img[src]',
                    getAttrs(dom) {
                        const height = dom.getAttribute(ImgSizeAttr.Height);
                        const width = dom.getAttribute(ImgSizeAttr.Width);
                        return {
                            [ImgSizeAttr.Src]: dom.getAttribute(ImgSizeAttr.Src),
                            [ImgSizeAttr.Alt]: dom.getAttribute(ImgSizeAttr.Alt),
                            [ImgSizeAttr.Title]: dom.getAttribute(ImgSizeAttr.Title),
                            [ImgSizeAttr.Loading]: dom.getAttribute(ImgSizeAttr.Loading),
                            [ImgSizeAttr.Height]: isNumber(height) ? height : null,
                            [ImgSizeAttr.Width]: isNumber(width) ? height : null,
                        };
                    },
                },
            ],
            toDOM(node) {
                return ['img', node.attrs];
            },
        },
        fromYfm: {
            tokenSpec: {
                name: imageNodeName,
                type: 'node',
                getAttrs: (tok) => {
                    var _a, _b;
                    return ({
                        [ImgSizeAttr.Src]: tok.attrGet(ImgSizeAttr.Src),
                        [ImgSizeAttr.Title]: tok.attrGet(ImgSizeAttr.Title),
                        [ImgSizeAttr.Height]: tok.attrGet(ImgSizeAttr.Height),
                        [ImgSizeAttr.Width]: tok.attrGet(ImgSizeAttr.Width),
                        [ImgSizeAttr.Loading]: tok.attrGet(ImgSizeAttr.Loading),
                        [ImgSizeAttr.Alt]: ((_b = (_a = tok.children) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.content) || null,
                    });
                },
            },
        },
        toYfm: (state, node) => {
            const attrs = node.attrs;
            state.write('![' +
                state.esc(attrs.alt || '') +
                '](' +
                state.esc(attrs.src) +
                (attrs.title ? ' ' + state.quote(attrs.title) : '') +
                getSize(attrs) +
                ')');
        },
    }));
};
function getSize({ width, height }) {
    if (width || height) {
        return ` =${width || ''}x${height || ''}`;
    }
    return '';
}
